import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { FONT, FONT_TYPE } from '@tornado-rdk/typography';
import { makeThemeColor, PRIMARY, QUATERNARY, TERTIARY } from '@tornado-rdk/theme';

export const TITLE_FONT_TYPE = FONT_TYPE.MAIN;

export const TITLE_FONT_NAME = FONT.OTTAWA_3;

export const EXTRA_HIGHLIGHT_FONT_NAME = FONT.BERLIN_1;

export const EXTRA_HIGHLIGHT_FONT_TYPE = FONT_TYPE.MAIN;

export const BORDER_COLOR = makeThemeColor(PRIMARY);

export const INNER_BORDER_COLOR = makeThemeColor(TERTIARY);

export const LINE1_COLOR = makeThemeColor(PRIMARY);

export const LINE2_COLOR = makeThemeColor(QUATERNARY);

export const LINE3_COLOR = makeThemeColor(QUATERNARY);

export const ITEMS_BY_BREAKPOINTS = {
  general: {
    [HD]: 2,
    [FULL_HD]: 2,
  },
  search: {
    [HD]: 2,
    [FULL_HD]: 2,
  },
};
